import NotFound from '../NotFound'
import Swap from '../Swap'
import { RedirectPathToSwapOnly } from '../Swap/redirects'
import { RouteConfig } from './types'

export const publicRoutes: RouteConfig[] = [
  {
    path: '/',
    element: Swap,
  },
  {
    path: 'send',
    element: RedirectPathToSwapOnly,
  },
  {
    path: 'swap',
    element: Swap,
  },
  {
    path: '/not-found',
    element: NotFound,
  },
]
